var generateUUID = require('./uuid');

angular.module('bbl.services.pubsub', [])
  .factory('pubsub', ['$rootScope', PubsubFactory]);

function PubsubFactory ($rootScope) {
  var $pubsub = $rootScope.$new(),
    uuids = {};

  /**
   * register Attach an unique id to passed handler, if there's none attached yet
   * @return true if uid was attached
   * @return undefined if it failed (uid already added)
   */
  function register(handler) {
    if(!handler.__$uid) {
      handler.__$uid = generateUUID();
    }

    if(uuids[handler.__$uid] !== undefined) {
      console.warn('handler', handler, 'already registered.');
      return;
    }

    return (uuids[handler.__$uid] = true);
  }

  /**
   * __handle Handle an event callback
   *   Will return undefined if uid was marked as unregistered
   * @param  {function} handler    Callback function
   * @param  {boolean} sliceFirst Slice first argument
   */
  function __handle(handler, sliceFirst) {
    return function() {
      if(uuids[handler.__$uid] !== true) {
        return;
      }

      handler.apply(0, [].slice.call(arguments, sliceFirst ? 1 : 0));
    };
  }

  /**
   * sub Subscribe handler to passed topic/subject
   * @param  {boolean} sliceFirst True if first callback argument needs to be sliced
   * @param  {string} topic
   * @param  {function} handler
   * @return {subject}            Subject that allows one to unsubscribe the passed handler
   */
  function sub (sliceFirst, topic, handler) {
    if(!register(handler)) {
      return;
    }

    $pubsub.$on(topic, __handle(handler, sliceFirst));
    return {unsub: unsub.bind(0, topic, handler)};
  }

  /**
   * once Call handler only once
   * @param  {string} topic
   * @param  {function} handler
   */
  function once (topic, handler) {
    var called = false;

    $pubsub.$on(topic, function onceHandler() {
      if(called) { return; }

      called = true;
      handler.apply(0, arguments);
    });
  }

  /**
   * unsub Mark handler as unregistered from the passed topic of events
   * @param  {string} topic
   * @param  {function} handler
   */
  function unsub(topic, handler) {
    if(!handler.__$uid || uuids[handler.__$uid] === undefined) {
      console.warn('handler', handler, 'not registered.');
      return;
    }

    uuids[handler.__$uid] = false;
  }

  /**
   * pub Publish topic with data
   * @param  {string} topic
   * @param  {any} data
   */
  function pub (topic, data) {
    $pubsub.$emit(topic, data);
  }

  /**
   * unsuball Unregister all events
   */
  function unsuball() {
    $pubsub.$destroy();
    $pubsub = $rootScope.$new();
  }

  return {
    _sub: sub.bind(0, true),
    sub: sub.bind(0, false),
    unsub: unsub,
    once: once,
    pub: pub,
    unsuball: unsuball,
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/app-pubsub.js
 ** module id = 154
 ** module chunks = 0
 **/